module.exports = __webpack_public_path__ + "static/media/gb-wls.7ab2bf3b.webp";